import useLayeredContent from './useLayeredContent'
import type { Consent } from '../../utils/consents-config'

export function useContentConsent() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getConsents() {
        return await queryAll<Consent>('consents')
    }

    async function getConsentBySlug(slug: string) {
        return await queryBySlug<Consent>('consents', slug)
    }

    return { getConsents, getConsentBySlug }
}
